import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
async function generateHash(data) {
  const encoder = new TextEncoder();
  const encodedData = encoder.encode(data);
  const hashBuffer = await window.crypto.subtle.digest('SHA-256', encodedData);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
  return hashHex;
}
const axiosInstance = axios.create({
  baseURL: `${process.env.REACT_APP_API_SERVER}/api/${uuidv4().replace(/-/g, '')}/`,
  headers: {
    'Content-Type': 'application/json'
  },
  withCredentials: false
});
const fetchServerPublicKey = async () => {
  try {
    const response = await axiosInstance.get('/public-key');
    const serverPublicKeyData = {
      publicKey: response.data.publicKey,
      publicKeyHash: await generateHash(response.data.publicKey)
    };
    sessionStorage.setItem('serverPublicKeyData', JSON.stringify(serverPublicKeyData));
    return true;
  } catch (error) {
    return false;
  }
};
export default fetchServerPublicKey;